import _ from 'lodash';
import { APP_AI_ALERT_METRIC_LIST, AIAlertMetric } from './metrics';

export const filterBasedOnTabType = (items, type) => {
  if (type === 'all') {
    return items;
  }
  const allItems = items.filter((item) => item.type === 'all');
  const typeSpecificItems = items.filter(
    (item) => item.type === type || (Array.isArray(item.type) && item.type.includes(type)),
  );
  return [...allItems, ...typeSpecificItems];
};

export const isAiAlertsDiagnosticsPage = () => {
  return window.location.pathname.includes('ai-alerts/diagnostics');
};

export const findDifferencesWithResult = (currentResults, previousResults) => {
  const changesInCommonResults = [];
  const removedSensitivities = [];
  const newlyAddedSensitivity = [];

  const filteredCurrentResults = currentResults.map((sensitivity) => {
    delete sensitivity.metricKey;
    return sensitivity;
  });

  // Find changed and extra objects
  previousResults.forEach((previousObj) => {
    const currentObj = _.find(filteredCurrentResults, { metric: previousObj.metric });
    if (currentObj) {
      if (!_.isEqual(currentObj, previousObj)) {
        changesInCommonResults.push(currentObj);
      }
    } else {
      removedSensitivities.push(previousObj);
    }
  });

  // Find extra objects in originalArray
  filteredCurrentResults.forEach((currentObj) => {
    const compareObj = _.find(previousResults, { metric: currentObj.metric });
    if (!compareObj) {
      newlyAddedSensitivity.push(currentObj);
    }
  });

  const removedSensitivitiesUpdated = removedSensitivities.map((sensitivity) => {
    return { ...sensitivity, isDeleted: true };
  });

  const buildResponse = [
    ...changesInCommonResults,
    ...newlyAddedSensitivity,
    ...removedSensitivitiesUpdated,
  ];

  return buildResponse;
}

export const groupAiAlertMetrics = (metrics: AIAlertMetric[]) => {
  const adMetrics = [] as AIAlertMetric[];
  const appMetrics = [] as AIAlertMetric[];
  const contentMetrics = [] as AIAlertMetric[];
  metrics.forEach((it) => {
    if (it.pulse4Key.startsWith('AD_')) {
      return adMetrics.push(it);
    }
    if (APP_AI_ALERT_METRIC_LIST.includes(it.pulse4Key)) {
      return appMetrics.push(it);
    }
    return contentMetrics.push(it);
  });

  return {
    adMetrics,
    appMetrics,
    contentMetrics,
  };
};
